import DesertedTowerList from "../../../../src/data/articles/a-guided-tour-of-the-wizards-tower/DesertedTowerList.tsx";
import * as React from 'react';
export default {
  DesertedTowerList,
  React
};